import React, { createContext, useContext, useState } from 'react';

type PortalContextType = {
    legacyBaseUrl: string | null;
    setLegacyBaseUrl: React.Dispatch<React.SetStateAction<string | null>>;
}

const PortalContext = createContext<PortalContextType | undefined>(undefined);

export const PortalProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const [legacyBaseUrl, setLegacyBaseUrl] = useState<string | null>(null);

    return (
        <PortalContext.Provider value={{ legacyBaseUrl, setLegacyBaseUrl }}>
            {children}
        </PortalContext.Provider>
    );
};

export const usePortalContext = (): PortalContextType => {
    const context = useContext(PortalContext);
    if (!context) {
        throw new Error('usePortalContext must be used within a PortalProvider');
    }
    return context;
}